import signedFetch from '../util/signedFetch.js';

export default (userId, orgIds, currentOrgId, platform) =>
  signedFetch('getIdentityDetails', `${__API_BASE__}/identity`, 'POST', {
    userId,
    orgIds,
    currentOrgId,
    platform
  });
